export default "New weather effects are in the works.";